import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { handleGoogleCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        try {
          await handleGoogleCallback(sessionId);
          // Clear the hash and navigate
          window.history.replaceState(null, '', window.location.pathname);
          navigate('/', { replace: true });
        } catch (error) {
          console.error('Auth callback error:', error);
          const detail = error.response?.data?.detail || '';
          if (detail.includes('Kein Konto')) {
            // User not registered — redirect to registration
            window.history.replaceState(null, '', window.location.pathname);
            navigate('/mitglied-werden', { replace: true, state: { error: detail } });
          } else {
            window.history.replaceState(null, '', window.location.pathname);
            navigate('/login', { replace: true, state: { error: detail || 'Anmeldung fehlgeschlagen' } });
          }
        }
      } else {
        navigate('/login', { replace: true });
      }
    };

    processCallback();
  }, [handleGoogleCallback, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-primary animate-spin mx-auto mb-4" />
        <p className="text-text-secondary">Authentifizierung wird verarbeitet...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
